import { t } from 'i18next';
import { Task, TaskGuest } from '@admiin-com/ds-graphql';
import OnboardingMessage from '../../../../components/InvoiceCreateForm/OnboardingMessage';
import React from 'react';

export const SignedBox = (props: {
  downloadDocument: () => Promise<void>;
  onNext?: () => void;
  nextButtonText?: string;
  taskGuest: TaskGuest | Task;
}) => {
  const downloadDocumentTitle = t('downloadDocument', { ns: 'taskbox' });

  return (
    <OnboardingMessage
      lottiePath={'/tick.lottie'}
      title={t('documentSigned', { ns: 'taskbox' })}
      description={
        <>
          <span>
            {t('documentSignedDescription', {
              ns: 'taskbox',
            })}
          </span>{' '}
          <br />
          <span>
            {props.onNext
              ? `${t('Redirecting you to the next flow...', { ns: 'taskbox' })}`
              : ''}
          </span>
        </>
      }
      onGetStarted={props.onNext ? props.onNext : props.downloadDocument}
      buttonTitle={props.onNext ? props.nextButtonText : downloadDocumentTitle}
      onClose={props.onNext ? props.downloadDocument : undefined}
      closeButtonText={
        props.onNext ? downloadDocumentTitle : props.nextButtonText
      }
    />
  );
};
